import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';

export const escolhaVagasRoutes: Routes = [
  {
    path: 'escolha-vagas',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Escolha de Vagas',
      breadcrumb: [{ label: 'Escolha de Vagas', url: '/escolha-vagas' }],
      roles: [
        'ROLE_ESCOLHA_MUNICIPIO_CONSULTAR',
        'ROLE_ESCOLHA_MUNICIPIO_CADASTRAR',
        'ROLE_ESCOLHA_MUNICIPIO_EDITAR',
        'ROLE_ESCOLHA_MUNICIPIO_EXCLUIR',
      ],
      escolhaVagasExibirSelecaoChamada: true,
      escolhaVagasEtapaParametrizacaoId: null,
    },
    loadComponent: () =>
      import('./escolha-vagas.component').then((m) => m.EscolhaVagasComponent),
  },
];
